var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7991 7.67123C19.6707 7.26626 19.3205 6.97954 18.9078 6.94124L13.2787 6.41709L11.0541 1.07521C10.8898 0.682743 10.5161 0.429443 10.1001 0.429443C9.68415 0.429443 9.31027 0.682743 9.14707 1.07521L6.92242 6.41709L1.29245 6.94124C0.879751 6.9803 0.530277 7.26702 0.40114 7.67123C0.272746 8.07621 0.39132 8.5204 0.703452 8.80116L4.95859 12.628L3.70396 18.2955C3.61217 18.7122 3.76987 19.1431 4.10699 19.3931C4.2882 19.5281 4.5011 19.5956 4.71474 19.5956C4.89833 19.5956 5.08207 19.5455 5.24617 19.4448L10.1001 16.4681L14.9532 19.4448C15.3092 19.663 15.7569 19.643 16.0933 19.3931C16.4304 19.1431 16.5881 18.7122 16.4963 18.2955L15.2417 12.628L19.4968 8.80116C19.8088 8.5204 19.9275 8.07712 19.7991 7.67123Z",
    fill: "#7A297F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5465538fd8d346d94d54eca147dca28e.svg";
export { ForwardRef as ReactComponent };